import { size } from 'lodash';

export default {
    buttons: {
        start: 'Bắt đầu',
        end: 'Kết thúc hoạt động',
        submit: 'Nộp bài',
        next: 'Câu hỏi tiếp theo',
        result: 'Xem kết quả',
        nextModule: 'Tiếp theo',
        selfDone: 'Hoàn thành tự học',
        taskDone: 'Hoàn thành bài tập',
        moduleStart: 'Bắt đầu hoạt động',
    },
    teacher: {
        setting: 'Cài đặt hoạt động',
        wayOfProgress: 'Cách tiến hành',
        wayOfReading: 'Cách đọc',
        title: 'Tiêu đề hoạt động',
        guide: 'Hướng dẫn hoạt động',
        tooltip: `
        <span class="tooltip_list">
            <strong>Cùng Giáo viên</strong>
            <span>Giải từng câu hỏi một cùng Giáo viên</span>
         </span>
         <span class="tooltip_list">
            <strong>Tự học</strong>
            <span>Học sinh tự giải toàn bộ câu hỏi theo tốc độ của mình</span>
        </span>
        `,
        screen: 'Màn hình hoạt động',
        content: ({ values }: { values: { title?: string } }) => {
            const { title } = values;
            if (title) {
                return `Nội dung hoạt động <span>${title}</span>`;
            }
            return 'Nội dung hoạt động';
        },
        summary: 'Tóm tắt hoạt động',
    },
    alert: {
        wrong: 'Ồ, sai rồi. Hãy thử lại nhé.',
        waiting: () => {
            const messages = [
                'Xong rồi! Hãy đợi một lát nhé.',
                'Tốt lắm! Hãy đợi một lát nhé.',
                'Làm tốt lắm! Hãy đợi một lát nhé.',
            ];
            return messages[Math.floor(Math.random() * size(messages))];
        },
    },
    question: 'Câu hỏi',
    answerRate: 'Độ chính xác',
    relation: 'Mối quan hệ {relation}',
    allDone: 'Đã hoàn thành tất cả các câu hỏi. Hãy kết thúc hoạt động!',
    champion: 'Nhà vô địch',
    allSelect: 'Chọn tất cả',
    majorVocabulary: 'Từ vựng chính',
    remainingVocabulary: 'Từ vựng còn lại',
    students: {
        errorTooltip: 'Học sinh đang ngoại tuyến',
        progress: {
            title: ({ values }: { values: { isOngoing: boolean } }) => {
                const { isOngoing } = values;
                return `${isOngoing ? 'Tình trạng' : 'Kết quả'} theo Học sinh`;
            },
        },
        standby: 'Chưa bắt đầu',
        notAttended: 'Chưa tham gia',
        inProgress: 'Đang tiến hành',
        notCompleted: 'Chưa hoàn thành',
        completed: 'Hoàn thành',
    },
    modal: {
        title: 'Kết thúc hoạt động',
        message: 'Bạn có muốn kết thúc hoạt động không?',
    },
    state: {
        correct: 'Đúng',
        wrong: 'Sai',
    },
    toast: {
        addStarStudent: 'Đã tặng Sao khen thưởng cho {name}',
        addAllStar: 'Đã tặng Sao khen thưởng cho tất cả học sinh ({length})',
        failedStar: 'Tặng Sao khen thưởng thất bại',
        undo: 'Hoàn tác',
        undoFailed: 'Hoàn tác Sao khen thưởng thất bại',
    },
};
